<template>
    <div>
        <template v-if="options.length > 0">
            <ul class="mb-0 pl-4">
                <template v-for="option in options">
                    <li>{{ option.label }}</li>
                </template>
            </ul>
        </template>
        <template v-else>
            <em class="text-muted" style="font-size: .875rem">
                Aucune option sélectionnée
            </em>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            registrant: Object,
            session: Object,
        },
        computed: {
            options() {
                return (this.registrant.options ?? []).map(id => this.session.options.find(option => option.id === id));
            },
        }
    }
</script>
